import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { CouponType } from 'app/views/campaign-3/models/campaign-3-info-base.model';
import { MessageInstanceObject, MessageInstanceRuleTypes, MessageInstanceObjectTypes } from 'app/views/campaign-3/models/campaign-3.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { MessageService } from 'primeng/primeng';

@Component({
  selector: 'app-message-3-action-type',
  templateUrl: './message-3-action-type.component.html',
  styleUrls: ['./message-3-action-type.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Message3ActionTypeComponent implements OnInit {


  @Input() ui_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() couponType: CouponType = null;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() readOnly: boolean = false;
  @Input() formSchema: any;
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];

  @ViewChild('clienti_destinati_promo') clienti_destinati_promo: FormFields;
  @ViewChild('tipo_attuazione_promo') tipo_attuazione_promo: FormFields;


  //elementi che regolano il p-selectButton
  stateOptions: any[];
  cities: any[];

  fieldModel = {
    customerpromo: "",
    promotype: "",
    generationCoupon: ""
  }
  hideGenerationCouponStatic: boolean = false;

  disabled = {
    tutti: false,
    noloyalty: false
  }

  show = {
    warningActionType: false,
    form: false
  }

  valid: boolean = true;

  //evento che volevo chiamare se la validazione fosse andata a buon termine
  @Output() validationResult: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();
  @Output() actionDynamicChanged = new EventEmitter<boolean>();
  public isActionDynamicFromChild: boolean = false;
  isActionDynamic:boolean=false;


  //valore di couponGeneration dopo la selezione

  constructor(
    public srvCampaign3: Campaign3Service,
    private srvMessage: MessageService,
    private translate: TranslateService
  ) {

  }





  ngOnInit(): void {

    this.show.form = true;
    console.log("formSchema", this.formSchema)
    if (this.ui_mode == this.srvCampaign3.ui_modes.CREATE) {
      let customerPromoValue = (this.formSchema.form.clienti_destinati_promo && this.formSchema.form.clienti_destinati_promo.default) ? this.formSchema.form.clienti_destinati_promo.default : this.srvCampaign3.clientiDestinatiPromo.LOY;
      this.fieldModel.customerpromo = customerPromoValue;

      let promoTypeValue = (this.formSchema.form.tipo_attuazione_promo && this.formSchema.form.tipo_attuazione_promo.default) ? this.formSchema.form.tipo_attuazione_promo.default : this.srvCampaign3.tipoAttuazionePromo.PROMO;
      this.fieldModel.promotype = promoTypeValue;
      this.fieldModel.generationCoupon = this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code;
    }
    else if (this.ui_mode == this.srvCampaign3.ui_modes.EDIT) {
      if (this.messageInstanceObject.flgCouponingMethod == this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode) {
        this.fieldModel.generationCoupon = this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code;
      }
      else if (this.messageInstanceObject.flgCouponingMethod == this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.shortCode) {
        this.fieldModel.generationCoupon = this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code;
      }

      var self = this;
      setTimeout(function () {

        self.fieldModel.customerpromo = self.messageInstanceObject.targetLoyaltyClass;
        self.clienti_destinati_promo.fieldModel = self.messageInstanceObject.targetLoyaltyClass;

        self.fieldModel.promotype = self.messageInstanceObject.promoEmission;
        self.tipo_attuazione_promo.fieldModel = self.messageInstanceObject.promoEmission;
      }, 1000);

    }

    // this.onClickGenMethod(this.fieldModel.generationCoupon);
  }
  onClickGenMethod(type: string) {

    if (!this.readOnly) {

      //se si sta scegliendo statico
      if (type == this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code) {

        //se ha date di fruizione variabbili, allora deve essere dinamica (va in conflitto con la scelta in planning di flg_rolling)
        if (this.messageInstanceObject.flgRolling == "1") {
          this.srvMessage.add({
            severity: 'error',
            summary: 'Error',
            detail: this.translate.instant('campaign.promo_variable_dates_type'),
            life: 5000
          });
          this.setMessageInstanceGenMethod(this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code);
          return;
        }

        //se ha coupon ripetibile, allora deve essere dinamica
        if (this.messageInstanceObject.couponUseType == "R") {
          this.srvMessage.add({
            severity: 'error',
            summary: 'Error',
            detail: this.translate.instant('campaign.coupon_repeatable_issuance'),
            life: 5000
          }); this.setMessageInstanceGenMethod(this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code);
          return;
        }

        //se sono state definite soglie di emissione deve essere dinamica
        //non serve controllo a fruition perchè non esiste
        let CV_rules = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "CV").id);
        if (CV_rules) {
          let CV_rules_PTRE = CV_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PTRE").id);
          if (CV_rules_PTRE) {
            this.srvMessage.add({
              severity: 'error',
              summary: 'Error',
              detail: this.translate.instant('campaign.promo_consumption_threshold'),
              life: 5000
            }); this.setMessageInstanceGenMethod(this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code);
            return;
          }
        }

        let AC_rules = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "AC").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);
        if (AC_rules) {
          let AC_rules_TACM = AC_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "TACM").id);
          if (AC_rules_TACM) {
            this.srvMessage.add({
              severity: 'error',
              summary: 'Error',
              detail: this.translate.instant('campaign.promo_accumulators_issuance'),
              life: 5000
            });
            this.setMessageInstanceGenMethod(this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code);
            return;
          }
        }

        //se è stato premuto su statico e ha passato tutti i controlli superiori, allora setta il valore loyalty al radio button
        if (this.fieldModel.customerpromo != this.srvCampaign3.clientiDestinatiPromo.LOY) {
          this.srvMessage.add({
            severity: 'error',
            summary: 'Error', // Mantieni in inglese
            detail: this.translate.instant('campaign.promo_customers_value_changed'),
            life: 5000
          }); this.setMessageInstanceCustomerPromo(this.srvCampaign3.clientiDestinatiPromo.LOY)
        }

      }
      else {
      }

      this.setMessageInstanceGenMethod(type);
    }
  }
  onChangeTipoPromo(value: string) {
    this.fieldModel.promotype = value;
    if (this.tipo_attuazione_promo) {
      this.tipo_attuazione_promo.fieldModel = value;
    }

  }
  onActionDynamicChanged(value: boolean) {
  this.isActionDynamicFromChild = value;

  // puoi ora passarla a un altro figlio
}




  setMessageInstanceGenMethod(type: string) {

        this.isActionDynamic = (type === this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code);
this.actionDynamicChanged.emit(this.isActionDynamic);
    //STATIC o DYNAMIC
    this.fieldModel.generationCoupon = type;
    this.messageInstanceObject.flgCouponingMethod = this.fieldModel.generationCoupon == this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code ? this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.shortCode : (this.fieldModel.generationCoupon == this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code ? this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode : null);
    this.messageInstanceObject.targetLoyaltyClass = this.fieldModel.customerpromo;
    // this.messageInstanceObject.targetLoyaltyClass = (this.fieldModel.customerpromo == "loyalty" ? "LOY" : (this.fieldModel.customerpromo == "noloyalty" ? "NOLOY" : (this.fieldModel.customerpromo == "tutti" ? "ALL" : null)));
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  onChangeCustomerPromo(type: string) {
    if (!this.readOnly) {
      if (type != this.srvCampaign3.clientiDestinatiPromo.LOY && this.fieldModel.generationCoupon == this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code) {
        this.srvMessage.add({
          severity: 'error',
          summary: 'Error', // Mantieni in inglese
          detail: this.translate.instant('campaign.promo_static_value_loyalty'),
          life: 5000
        });
        this.setMessageInstanceCustomerPromo(this.srvCampaign3.clientiDestinatiPromo.LOY);
        return;
      }
      if (!this.messageInstanceObject || !this.messageInstanceObject.messageInstanceRule) {
  return;
}

      if (type != this.srvCampaign3.clientiDestinatiPromo.LOY) {
        let AC_rules = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "AC").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);
        if (AC_rules) {
          let AC_rules_TACM = AC_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "TACM").id);
          if (AC_rules_TACM) {
            this.srvMessage.add({
              severity: 'error',
              summary: 'Error', // Mantieni in inglese
              detail: this.translate.instant('campaign.promo_accumulators_loyalty'),
              life: 5000
            });
            this.setMessageInstanceCustomerPromo(this.srvCampaign3.clientiDestinatiPromo.LOY);
            return;
          }
        }
      }

      if (type != this.srvCampaign3.clientiDestinatiPromo.LOY) {
        let LM_rules = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "LM").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);
        if (LM_rules) {
          let LM_rules_LMNC = LM_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "LMNC").id);
          let LM_rules_PMCT = LM_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMCT").id);
          let LM_rules_PMTC = LM_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMTC").id);

          if (LM_rules_LMNC || LM_rules_PMCT || LM_rules_PMTC) {
            this.srvMessage.add({
              severity: 'error',
              summary: 'Error', // Mantieni in inglese
              detail: this.translate.instant('campaign.promo_emission_limits_loyalty'),
              life: 5000
            }); this.setMessageInstanceCustomerPromo(this.srvCampaign3.clientiDestinatiPromo.LOY);
            return;
          }
        }
      }

      if (type != this.srvCampaign3.clientiDestinatiPromo.LOY) {
        let PT_rules = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "PT").id);
        if (PT_rules) {
          let PT_rules_TDIS = PT_rules.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "TDIS").id);

          if (PT_rules_TDIS) {
            this.srvMessage.add({
              severity: 'error',
              summary: 'Error', // Mantieni in inglese
              detail: this.translate.instant('campaign.promo_distribution_list_loyalty'),
              life: 5000
            });
            this.setMessageInstanceCustomerPromo(this.srvCampaign3.clientiDestinatiPromo.LOY);
            return;
          }
        }
      }
      this.setMessageInstanceCustomerPromo(type);
    }


  }
  setMessageInstanceCustomerPromo(customerPromoValue: string) {
    var self = this;
    setTimeout(function () {
      self.fieldModel.customerpromo = customerPromoValue;
      self.clienti_destinati_promo.fieldModel = customerPromoValue;
      self.messageInstanceObject.targetLoyaltyClass = customerPromoValue;
      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);

  }
  /*
  checkHideStaticButton(){
    //KS-5420
    //Inibire scelta coupon "Statico" se Fase1 MSG-ALL o MSG-NOLOY o se fase 2 data ha variabili
    if(this.couponType.code == 'MSG-ALL' || this.couponType.code == 'MSG-NOLOY'){
      this.hideGenerationCouponStatic = true;
      this.fieldModel.generationCoupon = "DYNAMIC";
      this.messageInstanceObject.flgCouponingMethod = "D";
    }
    else{
      this.hideGenerationCouponStatic = false;
    }
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  */
  performValidationActionType(): boolean {

    if (this.fieldModel.promotype == "" || this.fieldModel.customerpromo == "" || this.fieldModel.generationCoupon == "") {
      this.valid = false;
    }
    else {
      this.clienti_destinati_promo.performValidation();
      this.tipo_attuazione_promo.performValidation();

      if (!this.clienti_destinati_promo.valid || !this.clienti_destinati_promo.valid) {
        this.valid = false;
      }
      else {
        this.valid = true;
      }

    }
    return this.valid;
    //this.validationResult.emit(this.valid);
  }

}


// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-action-type/message-3-action-type.component.ts